export const CHILD_MIN_AGE = 1;

export const CHILD_MAX_AGE = 17;

export const CHILD_DEFAULT_AGE = 5;
